module.exports = __webpack_public_path__ + "img/Multitasking-bro-cel.035374f7.png";